import { createSSRApp } from 'vue'
import App from './App.vue'
import store from './store'
import $utils from './utils'
import route from './utils/route'
import { http } from '@/utils/http'
import { routeInterceptor, requestInterceptor, prototypeInterceptor } from './interceptors'
import 'virtual:uno.css'
import '@/style/index.scss'

export function createApp() {
  uni.$u = $utils
  uni.$route = route
  uni.$http = http
  const app = createSSRApp(App)
  app.use(store)
  app.use(routeInterceptor)
  app.use(requestInterceptor)
  app.use(prototypeInterceptor)
  app.config.globalProperties.$utils = $utils
  app.config.globalProperties.$route = route
  return {
    app,
  }
}
